import React from "react";
import { PageHeader, Card } from "../components/ui-kit";
import { Hammer } from "lucide-react";

export const ComingSoon = ({ title, blurb }) => (
  <div className="mx-auto max-w-3xl">
    <PageHeader title={title} subtitle={blurb} />
    <Card className="flex items-center gap-3 text-sm" data-testid="coming-soon"><Hammer className="h-5 w-5 text-primary" /><p><b>Coming soon.</b> This module is on the Airfistuus™ roadmap and will appear here when it is released for your agency.</p></Card>
  </div>
);
